<template>
	<div>
		<el-menu class="el-menu-demo" mode="horizontal" background-color="#fff" text-color="#000"
			active-text-color="#000">
			<el-button class="buttonimg">
				<img class="showimg" :src="collapsed ? imgsq : imgshow" />
			</el-button>
			<el-submenu index="2" class="submenu">
				<template slot="title">{{ user.username }}</template>
				<el-menu-item @click="handpassWord()" index="2-2">修改密码</el-menu-item>
				<el-menu-item @click="fullPage(0)" index="2-3">数据可视化</el-menu-item>
				<el-menu-item @click="fullPage(1)" index="2-3">测试1</el-menu-item>
				<el-menu-item @click="fullPage(2)" index="2-3">测试2</el-menu-item>
				<el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
			</el-submenu>
		</el-menu>
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="30%"
			class="global-dialog-position">
			<el-form ref="form" :model="form" label-width="80px" :rules="rules">
				<el-row>
					<el-col :span="24">
						<el-form-item label="密码" prop="password">
							<el-input v-model="form.password" autocomplete="off" placeholder="请输入" show-password />
						</el-form-item>
					</el-col>
					<el-col :span="24" style="margin-top: 2vh">
						<el-form-item label="重复密码" prop="confirm_password">
							<el-input v-model="form.confirm_password" autocomplete="off" placeholder="请输入"
								show-password />
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForms">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import {
		delCookie,
		getCookie
	} from "../utils/util";
	import {
		getUserInfo
	} from "../api/userMG";
	import {
		loginOut
	} from "../api/userMG";
	import {
		editmyPassword
	} from "../api/user";
	import axios from "axios";
	import router from "http-proxy-middleware/lib/router";
	export default {
		name: "navcon",
		data() {
			return {
				userId: "",
				title: "修改密码",
				addOrEditOpen: false,
				form: {},
				collapsed: true,
				imgshow: require("../assets/img/gifhead.gif"),
				imgsq: require("../assets/img/gifhead.gif"),
				headimg: require("../assets/img/gifhead.gif"),
				user: {},
				// 校验
				rules: {
					confirm_password: [{
							required: true,
							message: "请输入重复密码",
							trigger: "blur"
						},
						{
							validator: this.validatePassword,
							trigger: "blur"
						},
					],
					password: [{
							required: true,
							message: "请输入密码",
							trigger: "blur"
						},
						{
							validator: this.validatePassword,
							trigger: "blur"
						},
						{
							pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/,
							message: "密码至少包含一个英文字母和一个数字，且长度不少于6位",
							trigger: "blur",
						},
					],
				},
			};
		},
		// 创建完毕状态(里面是操作)
		mounted() {
			this.user = JSON.parse(localStorage.getItem("userInfo"));
			this.$forceUpdate();
			this.getUserInfos();
		},
		methods: {
			fullPage(i) {
				var _path = '';
				switch (i) {
					case 0: {
						_path = "/fullPage";
						break;
					}
					case 1: {
						_path = "/fullPage1";
						break;
					}
					case 2: {
						_path = "/fullPage2";
						break;
					}
				}
				this.$router.push({
					path: _path,
				});
			},
			validatePassword(rule, value, callback) {
				if (value !== this.form.password) {
					callback(new Error("两次输入的密码不一致"));
				} else {
					callback();
				}
			},
			// 获取个人信息
			getUserInfos() {
				this.userId = localStorage.getItem('userId')
			},
			// 修改密码
			handpassWord() {
				this.$nextTick(() => {
					this.$refs.form.clearValidate();
				});
				this.addOrEditOpen = true;
			},
			submitForms() {
				this.$refs["form"].validate((vaild, err) => {
					if (vaild) {
						this.$confirm("确定修改密码吗？", "修改密码", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						}).then(async () => {
							const req = await editmyPassword(this.form);
							if (req.code !== 200) return this.$message.error("修改密码失败!");
							this.addOrEditOpen = false;
							this.$message.success("修改密码成功");
							this.getUserInfos();
							this.reset();
							delCookie("logintoken");
							this.$router.push({
								path: "/login",
							});
						});
					}
				});
			},
			// 清空
			reset() {
				this.form = {
					password: undefined,
					confirm_password: undefined,
				};
			},
			// 退出登录
			exit() {
				this.$confirm("退出登录, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						setTimeout(() => {
							const axios = require("axios");
							const getCookies = getCookie("logintoken");
							const apiUrl = process.env.VUE_APP_URL + "/admin/loginout"; // 替换为实际的API地址
							axios
								.post(apiUrl, {
									headers: {
										"Content-Type": "application/json",
										Cookie: getCookies,
									},
								})
								.then((response) => {
									// 请求成功的处理逻辑
									delCookie("logintoken");
									this.$router.push({
										path: "/login",
									});
								})
								.catch((error) => {
									delCookie("logintoken");
									this.$router.push({
										path: "/login",
									});
								});
						}, 800);
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消",
						});
					});
			},
			// 切换显示
			toggle(showtype) {
				this.collapsed = !showtype;
				this.$root.Bus.$emit("toggle", this.collapsed);
			},
			getout() {
				this.addOrEditOpen = false;
				this.$refs.form.clearValidate();
				this.reset();
			},
		},
	};
</script>
<style scoped>
	.el-menu-vertical-demo:not(.el-menu--collapse) {
		border: none;
	}

	.submenu {
		float: right;
	}

	.buttonimg {
		height: 60px;
		background-color: transparent;
		border: none;
	}

	.showimg {
		width: 26px;
		height: 26px;
		position: absolute;
		top: 17px;
		left: 17px;
	}

	.showimg:active {
		border: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue